import { Flex, Tag } from "@chakra-ui/react";
import * as AF from "src/types/formTemplate";

interface QuestionTagProps {
  question: AF.V2.Question;
  section?: AF.V2.Section;
}

interface SectionTagProps {
  question?: AF.V2.Question;
  section: AF.V2.Section;
}

type Props = QuestionTagProps | SectionTagProps;

export const InternalOnlyTag: React.FC<Props> = ({ question, section }) => {
  if (
    question &&
    (question.type === AF.V2.QuestionTypes.Grades ||
      question.permissionLevel === undefined ||
      question.permissionLevel === null ||
      question.permissionLevel.trim() === "")
  ) {
    return null;
  }

  if (section && !section.permissionLevel) {
    return null;
  }

  return (
    <Flex direction="row">
      <Tag size="sm">Internal-Only</Tag>
    </Flex>
  );
};

export function hasInternalOnlyTag(question: AF.V2.Question): boolean {
  return InternalOnlyTag({ question }) !== null;
}
